import type { FeatureFlagMap as FlagMap } from "@/lib/feature-flags/flags";

import { fetchJson } from "@/dashboard/hooks/api/fetch-json";
import { useTenantQuery } from "@/dashboard/hooks/query/use-tenant-query";

/* ------------------------------------------------------------------ */
/* Key builders                                                       */
/* ------------------------------------------------------------------ */

export const featureFlagsKey = () => ["feature-flags"] as const;

/* ------------------------------------------------------------------ */
/* Hook                                                               */
/* ------------------------------------------------------------------ */

export function useFeatureFlagsQuery(enabled: boolean) {
  return useTenantQuery<FlagMap>({
    queryKey: featureFlagsKey(),
    queryFn: () => fetchJson<FlagMap>("/api/dashboard/feature-flags"),
    enabled,
    staleTime: 30_000,
  });
}
